import { defineAsyncComponent } from 'vue'
export default {
  custom: defineAsyncComponent(() => import("C:/Users/zlq13/Desktop/work/official-web/layouts/custom.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("C:/Users/zlq13/Desktop/work/official-web/layouts/default.vue").then(m => m.default || m))
}